import React,{useEffect,useState} from "react";
import API from "../services/api";
import "./Reimbursement.css";

export default function SubmittedForms(){

const [data,setData]=useState([]);

useEffect(()=>{

fetchForms();

},[]);

const fetchForms=async()=>{

try{

const employeeName=
localStorage.getItem("username");

const res=
await API.get("/reimbursement");

const userForms=
res.data.filter(
item=>
item.employeeName
?.trim()
?.toLowerCase()===
employeeName
?.trim()
?.toLowerCase()
);

setData(userForms);

}catch(err){

console.log(err);

}

};

return(

<div className="container">

<h1 className="page-title">

Submitted Reimbursements

</h1>

<table className="reimbursement-table">

<thead>

<tr>

<th>Date</th>

<th>Title</th>

<th>Employer</th>

<th>Expense Details</th>

<th>Summary Details</th>

<th>Total</th>

<th>Status</th>

</tr>

</thead>

<tbody>

{data.length>0 ? (

data.map((item,index)=>(

<tr key={index}>

<td>
{
item.expenseRows &&
item.expenseRows.length > 0
?
item.expenseRows[0].date
:
"-"
}
</td>

<td>
{item.title}
</td>

<td>
{item.employer}
</td>

<td>

<div className="inner-box">

{item.expenseRows?.map(
(row,i)=>(

<div
key={i}
className="inner-item"
>

<b>#{i+1}</b>

<br/>

Date:
{row.date}

<br/>

Method:
{row.paymentMethod}

<br/>

Purpose:
{row.purpose}

<hr/>

</div>

)
)}

</div>

</td>

<td>

<div className="inner-box">

{item.summaryRows?.map(
(row,i)=>(

<div
key={i}
className="inner-item"
>

<b>#{i+1}</b>

<br/>

Description:
{row.description}

<br/>

Air/Rail:
₹ {row.airRail}

<br/>

Ground:
₹ {row.groundTrans}

<br/>

Lodging:
₹ {row.lodging}

<br/>

Meals:
₹ {row.meals}

<br/>

Other:
₹ {row.other}

<br/>

Total:
₹ {row.total}

<hr/>

</div>

)
)}

</div>

</td>

<td>

₹ {item.grandTotal}

</td>
<td>

<div>

<span
className={
item.status==="Approved"
?
"approved"
:
item.status==="Rejected"
?
"rejected"
:
"pending"
}
>
{item.status || "Pending"}
</span>

{item.status==="Rejected" && (

<div
style={{
color:"red",
fontSize:"12px",
fontWeight:"600",
marginTop:"6px"
}}
>
Please contact your Team Manager regarding the rejection.
</div>

)}

</div>

</td>
</tr>

))

) : (

<tr>

<td
colSpan="7"
style={{
textAlign:"center"
}}
>

No Submitted Forms Found

</td>

</tr>

)}

</tbody>

</table>

</div>

);

}